<jml-lib-code-editor
  #codeEditor
  [readonly]="readonly"
  [syntax]="syntax"
  [code]="code"
  saveButtonLabel="Übernehmen"
  [saveIcon]="saveIcon"
  (editedCode)="save($event)"
  (setDirty)="onDirtyChange($event)"
>
</jml-lib-code-editor>
